import type { HeroCarouselItemsContentProps } from '../hero-carousel'
import { isContentCenterAligned } from '../utils'
import { Badge } from './Badge'
import Button from './Button'
import Description from './Description'
import { PromoDate } from './PromoDate'
import Title from './Title'

interface ContentProps {
  contentAlignment: string
  content: HeroCarouselItemsContentProps
  textAlignment: CanvasTextAlign
}

const Content = ({
  contentAlignment,
  content,
  textAlignment,
}: ContentProps) => {
  const alignItems =
    textAlignment === 'left'
      ? 'flex-start'
      : textAlignment === 'right'
      ? 'flex-end'
      : 'center'

  const getPosition = () => {
    return !isContentCenterAligned(contentAlignment) ? 'static' : 'absolute'
  }

  const getTransform = () => {
    return !isContentCenterAligned(contentAlignment)
      ? 'translateX(0)'
      : 'translateX(-50%)'
  }

  const getWidth = () => {
    return !isContentCenterAligned(contentAlignment) ? '50%' : '450px'
  }

  const getPadding = () => {
    return !isContentCenterAligned(contentAlignment)
      ? { paddingBottom: '16px', paddingTop: '16px', paddingLeft: '8px' }
      : undefined
  }

  return (
    <div
      className="bottom-4 flex flex-col justify-center left-[50%] max-w-[90%] text-center top-4 sm:px-0 sm:w-[47.5%] order-1"
      style={{
        alignItems,
        position: getPosition(),
        transform: getTransform(),
        width: getWidth(),
        ...getPadding(),
      }}
    >
      <Badge content={content} textAlignment={textAlignment} />
      <Title title={content?.title} textAlignment={textAlignment} />
      <Description
        description={content?.description}
        textAlignment={textAlignment}
      />
      <Button button={content?.button} />
      <PromoDate textAlignment={textAlignment} content={content} />
    </div>
  )
}

export default Content
